import { onSleep } from "../../../utils/default";
import HTTPCore from "../../http.core";

class LocationHttpService extends HTTPCore {
  constructor() {
    super({});
  }
  //==============================
  setOpenModalTokenExpired;
  setTokenExpiredHandler(handler) {
    this.setOpenModalTokenExpired = handler;
  }
  handleTokenExpiration(open) {
    if (this.setOpenModalTokenExpired) {
      this.setOpenModalTokenExpired(open);
    } else {
      console.error("Token expired handler not set");
    }
  }
  //==============================
  getEnv() {
    return process.env.REACT_APP_ENDPOINT_SAT;
  }
  getToken() {
    let token = "";
    token = localStorage.getItem("at") || "";
    return `bearer ${token}`;
  }
  getRefreshToken() {
    let token = "";
    token = localStorage.getItem("rt") || "";
    return `bearer ${token}`;
  }
  async handleRefreshToken() {
    let response = null;
    try {
      response = await this.refreshToken();
    } catch { }
    if (response) {
      localStorage.setItem("at", response.access_token)
      localStorage.setItem("rt", response.refresh_token)
    } else {
      this.handleTokenExpiration(true)
      await onSleep(2000);
      try {
        await this.Logout()
      } catch { }
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_BASE_PATH}/login`;
    }
    return response;
  }
  //==============================
  Logout(param) {
    let token = this.getToken();
    let url = this.getEnv();
    let path = `/user/logout`
    let fullUrl = url + path
    return this.post(fullUrl, param,
      {
        headers: { Authorization: token }
      }
    );
  }
  refreshToken() {
    let token = this.getRefreshToken();
    let url = this.getEnv();
    let path = `/user/refresh-token`
    let fullUrl = url + path
    return this.get(fullUrl, {
      headers: { Authorization: token }
    });
  }
  //==============================
  async locationById(param) {
    const func = () => {
      let token = this.getToken();;
      let url = this.getEnv();
      let path = `/location/${param}`
      let fullUrl = url + path
      let response = this.get(fullUrl,
        {
          headers: { Authorization: token },
        },
      );
      return response;
    }
    let response = func();
    // ========== ========== ========== ==========
    try {
      await response;
    } catch (err) {
      if (err?.response?.data?.status === 401) {
        const check = await this.handleRefreshToken()
        if (check) {
          response = func();
          return response
        }
      }
      throw err
    }
    // ========== ========== ========== ==========
    return response;
  }
  async locationList() {
    const func = () => {
      let token = this.getToken();;
      let url = this.getEnv();
      let path = `/location/list`
      let fullUrl = url + path
      let response = this.get(fullUrl,
        {
          headers: { Authorization: token },
        },
      );
      return response;
    }
    let response = func();
    // ========== ========== ========== ==========
    try {
      await response;
    } catch (err) {
      if (err?.response?.data?.status === 401) {
        const check = await this.handleRefreshToken()
        if (check) {
          response = func();
          return response
        }
      }
      throw err
    }
    // ========== ========== ========== ==========
    return response;
  }
  async locationProvince() {
    const func = () => {
      let token = this.getToken();;
      let url = this.getEnv();
      let path = `/location/province`
      let fullUrl = url + path
      let response = this.get(fullUrl,
        {
          headers: { Authorization: token },
        },
      );
      return response;
    }
    let response = func();
    // ========== ========== ========== ==========
    try {
      await response;
    } catch (err) {
      if (err?.response?.data?.status === 401) {
        const check = await this.handleRefreshToken()
        if (check) {
          response = func();
          return response
        }
      }
      throw err
    }
    // ========== ========== ========== ==========
    return response;
  }
  async locationCreate(param) {
    const func = () => {
      let token = this.getToken();;
      let url = this.getEnv();
      let path = `/location`
      let fullUrl = url + path
      let response = this.post(fullUrl,
        param,
        {
          headers: { Authorization: token },
        },
      );
      return response;
    }
    let response = func();
    // ========== ========== ========== ==========
    try {
      await response;
    } catch (err) {
      if (err?.response?.data?.status === 401) {
        const check = await this.handleRefreshToken()
        if (check) {
          response = func();
          return response
        }
      }
      throw err
    }
    // ========== ========== ========== ==========
    return response;
  }
  async locationUpdate(param) {
    const func = () => {
      let token = this.getToken();;
      let url = this.getEnv();
      let path = `/location`
      let fullUrl = url + path
      let response = this.put(fullUrl,
        param,
        {
          headers: { Authorization: token },
        },
      );
      return response;
    }
    let response = func();
    // ========== ========== ========== ==========
    try {
      await response;
    } catch (err) {
      if (err?.response?.data?.status === 401) {
        const check = await this.handleRefreshToken()
        if (check) {
          response = func();
          return response
        }
      }
      throw err
    }
    // ========== ========== ========== ==========
    return response;
  }
  async locationRemove(id) {
    const func = () => {
      let token = this.getToken();;
      let url = this.getEnv();
      let path = `/location/${id}`
      let fullUrl = url + path
      let response = this.delete(fullUrl,
        {
          headers: { Authorization: token },
        },
      );
      return response;
    }
    let response = func();
    // ========== ========== ========== ==========
    try {
      await response;
    } catch (err) {
      if (err?.response?.data?.status === 401) {
        const check = await this.handleRefreshToken()
        if (check) {
          response = func();
          return response
        }
      }
      throw err
    }
    // ========== ========== ========== ==========
    return response;
  }
  async locationGetListByParam(param) {
    const func = () => {
      let token = this.getToken();;
      let url = this.getEnv();
      let path = `/location/list-by-param`
      let fullUrl = url + path
      let response = this.post(fullUrl,
        param,
        {
          headers: { Authorization: token }
        },
      );
      return response;
    }
    let response = func();
    // ========== ========== ========== ==========
    try {
      await response;
    } catch (err) {
      if (err?.response?.data?.status === 401) {
        const check = await this.handleRefreshToken()
        if (check) {
          response = func();
          return response
        }
      }
      throw err
    }
    // ========== ========== ========== ==========
    return response;
  }
  //==============================
}

export {
  LocationHttpService
};
